module.exports = __webpack_public_path__ + "img/EY__bg_md.2ac62547.png";